<template>
    <div id="ClientListTab" class="wrap btn-position-wrap">
        <loading
            :active.sync="isLoading"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="fullPage"
        ></loading>
        <md-field class="search-field" style="width:30%;">
            <md-icon>search</md-icon>
            <md-input v-model="search" v-on:keyup="searchList"></md-input>
        </md-field>
           <h3 v-if="clientList.length == 0" style="color:red;color: red;padding-left: 400px; margin-top: -40px;">
              Client not exists
           </h3>
        <md-list class="clients-wrap">
            <div class="collapsing-list-item" v-for=" (client, index) in clientList" :id="client.id" v-if="clientList != null">
                <md-list-item class="line-item client-line">
                    <div class="left-item" @click="navToClient(client)">
                        <b-tooltip title="Client Tours" triggers="focus" positioning="top">
                            <a class="client-nav" @click="navToClient(client)">
                                <h2>{{ client.companyName }}
                                    <div v-if="client.description!=null" @click="navToClient(client)">
                                        <small v-if="client.user">{{ client.description.substring(0, 90) }}<span v-if="client.description.length>=90">....</span></small>
                                    </div>
                                </h2>
                            </a>
                        </b-tooltip>
                    </div>
                    <div class="left-item" @click="navToClient(client)">
                        <b-tooltip title="Client Tours" triggers="focus" positioning="top">
                            <a class="client-nav" @click="navToClient(client)">
                                <div data-v-8248d938="" data-v-85b4f9ea="" id="progress-bar-line" class="progress-bar">
                                    <svg id="line-progress" style="height: 20px; width: 220px;">
                                        <line x1="0" y1="50%" x2="100%" y2="50%" stroke="#00A8CA" stroke-width="20"></line>
                                        <line x1="0" y1="50%" :x2="client.media_size_p" y2="50%" stroke="#228b22" stroke-width="20px"></line>
                                        <text x="45%" y="64%" style="display: inherit; fill: rgb(255, 255, 255); font-size: 10px; font-family: Helvetica; text-shadow: rgb(0, 0, 0) 1px 1px 1px;"> {{ client.media_length }}</text>
                                    </svg>
                                </div>
                            </a>
                        </b-tooltip>
                    </div>
                    <div class="right-item" @click="navToClient(client)">
                        <b-tooltip title="Client Tours" triggers="focus" positioning="top">
                            <span v-if="client.activeInactiveImages === 1" @click="navToClient(client)">
                                <img class="completeImages" src="static/img/complete.png">
                            </span>
                        </b-tooltip>
                    </div>
                    <b-tooltip title="Client Tours" triggers="focus" positioning="top">
                        <div class="right-item" @click="navToClient(client)">
                            <div class="el"></div>
                            <span v-if="client.user" class="d-flex">
                                <div class="el no-outline-btn" @click="navToClient(client)">
                                    <md-avatar v-if="hasAvatar(client)" class="md-avatar-icon">
                                        <img :src="getImageSrc(client.user.avatar)">
                                    </md-avatar>
                                    <md-avatar v-else class="md-avatar-icon blue">
                                        {{ getClientInitials(client) }}
                                    </md-avatar>
                                </div>
                                <div class="el position-width no-outline-btn" @click="navToClient(client)">
                                    <h4>{{ client.user.firstName + ' ' + client.user.lastName }}
                                        <small>{{ client.user.title }}</small>
                                    </h4>
                                </div>
                            </span>
                            <span v-else class="d-flex">
                                <div class="el no-outline-btn" @click="navToClient(client)">
                                    <md-avatar class=""></md-avatar>
                                </div>
                                <div class="el position-width no-outline-btn">
                                    <p></p>
                                </div>
                            </span>
                        </div>
                    </b-tooltip>
                    <div class="right-item" id="clientListDelete">
                        <b-tooltip title="Delete" triggers="focus" positioning="top">
                            <md-button class="md-icon-button" @click="confirmDelete(client.id, index)">
                                <md-icon>delete</md-icon>
                            </md-button>
                        </b-tooltip>
                        <b-tooltip title="Edit" triggers="focus" positioning="top">
                            <md-button id="clientListEdit" class="md-icon-button" @click="editClient(client)">
                                <md-icon>mode_edit</md-icon>
                            </md-button>
                        </b-tooltip>
                    </div>
                    <img :src="client.img" id="imgeExpand" @click="clickExpandFunc(index)" class="client_list_img " style="
          ">
                </md-list-item>
                <md-listz v-if="client.expended" class="right-item" style="padding-right:5px;">
                    <md-list-item class="md-inset">
                        <div class="client-info-wrap line-item">
                            <div class="right-item">
                                <div class="el">
                                    <div v-if="client.user" class="info-element">
                                        <dl>
                                            <dt>Office</dt>
                                            <dd>{{ getFullOfficeNumber(client) }}</dd>
                                            <dt>Direct</dt>
                                            <dd>{{ getFullDirectNumber(client) }}</dd>
                                            <dt>Email</dt>
                                            <dd>{{ client.user.email }}</dd>
                                        </dl>
                                    </div>
                                    <div v-else class="info-element">
                                        This client has no contacts.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </md-list-item>
                </md-listz>
            </div>
        </md-list>
        <div class="bottom-btn-position">
            <div class="wrap">
                <md-button @click="clickNewClient()" class="add-tour-button md-fab md-accent md-primary">
                    <md-icon>add</md-icon>
                </md-button>
            </div>
        </div>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Are you sure you want to delete this client?
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="deleteClient(clientId,clientIndex)">DELETE</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialog = false">CANCEL</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {lastReleaselist} from '../../services/ReleaseService.js';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  data () {
    return {
      showDeleteDialog: false,
      expand: [],
      expandShow: [],
      expandHide: [],
      clientId: '',
      clientIndex: '',
      value: 33.333333333,
      max: 50,
      Supportemail: 'rajeshs@gmail.com',
      latestVersion: '',
      isLoading: false
    };
  },
  computed: {
    ...mapGetters('client', ['clientList', 'currentClient'])
  },
  components: {
    Loading
  },
  methods: {
    ...mapActions('client', ['loadClient', 'resetClient', 'loadClientEditor']),
    hasAvatar (client) {
      return client.user.avatar !== null;
    },
    getImageSrc (avatar) {
      return 'static/img/' + avatar;
    },
    clickExpandFunc (index) {
      let client = this.clientList[index];
      if (client.expended === false) { // arrow up
        client.img = 'static/img/image-rotate.png';
        client.expended = true;
      } else { // arrow down
        client.img = 'static/img/arrow.png';
        client.expended = false;
      }
      this.clientList[index] = client;
    },
    confirmDelete (id, index) {
      this.showDeleteDialog = true;
      this.clientId = id;
      this.clientIndex = index;
    },
    deleteClient (id, index) {
      axios.post('api/client/delete/', {
        id: id
      }).then((response) => {
        this.showDeleteDialog = false;
        this.clientList.splice(index, 1);
      }).catch((error) => {
        console.error(error);
      });
    },
    getClientInitials (client) {
      let clientInitials = '';

      if (client.user.firstName) {
        clientInitials += client.user.firstName.charAt(0);
      }
      if (client.lastName) {
        clientInitials += client.user.lastName.charAt(0);
      }
      if (clientInitials.length < 1) {
        clientInitials = 'NA';
      }

      return clientInitials;
    },
    getFullOfficeNumber (client) {
      let fullOfficeNum;
      if (client.user.officePhone !== null) {
        fullOfficeNum = client.user.officePhone;
        if (client.user.officeExt !== null) {
          fullOfficeNum += ', ' + client.user.officeExt;
        }
      } else {
        fullOfficeNum = 'Phone Not Listed';
      }
      return fullOfficeNum;
    },
    getFullDirectNumber (client) {
      let fullDirectNum;
      if (client.user.directPhone !== null) {
        fullDirectNum = client.user.directPhone;
        if (client.user.directExt !== null) {
          fullDirectNum += ', ' + client.user.directExt;
        }
      } else {
        fullDirectNum = 'Phone Not Listed';
      }

      return fullDirectNum;
    },
    async navToClient (client) {
      await this.loadClient({isAdmin: false, clientId: client.id});
      this.$router.push('/client/tours');
    },
    clickNewClient () {
      this.$router.push('/client/new');
    },
    editClient (client) {
      this.loadClientEditor(client);
      this.$router.push('/client/edit');
    },
    clients () {
      return axios.get('api/clients');
    },
    async searchList () {
      let searchval = this.search;
      await this.loadClient({isAdmin: true, search: searchval});
    }
  },
  async mounted () {
    let latestThis = this;
    this.isLoading = true;
    lastReleaselist().then(function (defs) {
      latestThis.latestVersion = defs.data[0].v_no;
      latestThis.isLoading = false;
    });
    await this.loadClient({isAdmin: true, search: ''});
    if (this.currentClient) {
      this.resetClient();
    }
  }
};
</script>
<style lang="scss">
.md-list-item-content > .md-icon:last-child {
    margin: 0 !important;
}

.client-line .left-item {
    width: 60%;
    padding-top: 20px;
    padding-bottom: 20px;
}

a.client-nav {
    color: var(--md-theme-default-text-primary-on-background, rgba(0, 0, 0, 0.87));
    text-decoration-line: none !important;
    text-underline: none !important;

    h2 {
        color: var(--md-theme-default-text-primary-on-background, rgba(0, 0, 0, 0.87));
        text-decoration-line: none !important;
        text-underline: none !important;
    }
}

.bottom-btn-position {
    position: fixed !important;
    right: 30px !important;
    bottom: 14% !important;

    button {
        z-index: 15;
    }
}

.bottom-btn-positionContact {
    position: fixed !important;
    right: -3.5% !important;
    bottom: -7px !important;

    button {
        z-index: 999;
    }
}

.edit-button {
    display: inline-block;
    margin-left: 55px;
}

.md-dialog-actions {
    height: 62px;
    padding: 0px 8px 0px 3px;
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: end;
    justify-content: flex-end;
    position: relative;
}

#clientListEdit .md-button .md-ripple {
    padding: 0 0px;
    display: flex;
    justify-content: center;
    align-items: center;
}

#clientListEdit .md-button .md-ripple {
    padding: 0 0px;
    display: flex;
    justify-content: center;
    align-items: center;
}

#clientListDelete .md-button .md-ripple {
    padding: 0 0px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.ManualBtn {
    display: inline-block !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    -ms-touch-action: manipulation !important;
    touch-action: manipulation !important;
    cursor: pointer !important;
    background-image: none !important;
    border: 1px solid transparent !important;
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.42857143 !important;
    border-radius: 4px !important;
    color: #fff !important;
}

.ManualBtndelete {
    background-color: #d9534f !important;
}

.ManualBtncancel {
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
}

.full-btn {
    padding-right: 20px !important;
    padding-left: 10px !important;
}

#clientListDelete {
    display: flex;
}

.d-flex {
    display: flex;
}


@media only screen and (max-width: 1024px) {
    .clients-wrap .client-line .right-item .el {
        margin-left: 16px;
    }
    .edit-button {
        margin-left: 0;
    }
    .clients-wrap .client-line .right-item .el.position-width {
        width: 210px;
    }
    a.client-nav {
        white-space: initial;
    }
}

@media only screen and (max-width: 768px) {
    .clients-wrap .client-line .right-item .el.position-width {
        width: 120px;
        white-space: initial;
    }
    .md-list-item-content .right-item {
        display: flex;
        align-items: center;
    }
    .el:empty {
        display: none;
    }

    .md-list-item-content .right-item span.user-info {
        display: flex;
    }
}

.completeImages {
    width: 14px;
    margin-right: 10px;
}

.md-button.md-fabSupport {
    border-radius: 10px !important;
    width: fit-content;
}

button.md-button.ManualBtn.ManualBtndelete.md-theme-default span.md-button-content {
    font-size: 15px;
}

button.md-button.ManualBtn.ManualBtncancel.md-theme-default span.md-button-content {
    font-size: 15px;
}

.md-list-item-container.md-button-clean:hover {
    background-color: #e2e2e2;
}

.clients-wrap .client-line h2 {
    font-weight: 400;
    font-size: 16px;
}

.clients-wrap .client-line small {
    color: #2d2d2d;
    white-space: nowrap;
    width: 350px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.client_list_img {
    width: 24px;
    height: 20px;
    margin-left: 12px;
    border-radius: 100px;
    margin-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/client/ClientListTab.vue